'use client';

import type { Message } from '@repo/api';
import { MessageVideoCard } from './MessageVideoCard';

interface MediaCardProps {
  message: Message;
}

export function MediaCard({ message }: MediaCardProps) {
  if (message.displayType === 'video') {
    return <MessageVideoCard message={message} />;
  }
  return null;
}
